import {useState} from "react";
import {FiExternalLink} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";
import {Tooltip} from "@/components/toolTip/Tooltip.tsx";
import {BrandInfo} from "@/lib/queries/accounts.ts";
import {getStatusPagePreviewURL} from "@/pages/statuspages/utils/urls.ts";

interface StatusPagePublicUrlIconProps {
  statusPageId: number;
  publicUrl: string;
  cnameUrl?: string | null;
  brand: BrandInfo;
}

export const StatusPagePublicUrlIcon = ({statusPageId, publicUrl, cnameUrl, brand}: StatusPagePublicUrlIconProps) => {
  const [open, setOpen] = useState(false);
  const defaultUrl = getStatusPagePreviewURL(brand, statusPageId, publicUrl);

  if (!cnameUrl) {
    return (
      <a
        href={defaultUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="pulse-color-blue-500 d-flex align-items-center"
        title="Open public URL in new tab"
      >
        <Icon icon={FiExternalLink} />
      </a>
    );
  }

  return (
    <Tooltip
      open={open}
      onOpenChange={setOpen}
      placement="bottom"
      variant="light"
      showArrow={false}
      tooltipContent={
        <div className="d-flex flex-column p-2">
          <a
            className="pulseTextBodySmall d-flex align-items-center gap-1 py-1"
            href={defaultUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {defaultUrl} <Icon icon={FiExternalLink} />
          </a>
          <a
            className="pulseTextBodySmall d-flex align-items-center gap-1 py-1"
            href={cnameUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {cnameUrl} <Icon icon={FiExternalLink} />
          </a>
        </div>
      }
    >
      <span
        className="pulse-color-blue-500 d-flex align-items-center cursor-pointer"
        title="View public URLs"
        role="button"
        tabIndex={0}
        onClick={() => setOpen((prev) => !prev)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen((prev) => !prev);
          }
        }}
      >
        <Icon icon={FiExternalLink} />
      </span>
    </Tooltip>
  );
};
